import { getUserSavedCourses } from "../api";
import { useApiGet } from "@/hooks/useApi";

export function useGetUserSavedCourses(username) {
	const { data, isPending, isSuccess, isError, error } = useApiGet({
		key: ["courses", "saved", "users", `${username}`],
		fn: () => getUserSavedCourses(username),
	});

	const { courses } = data || { courses: [] };

	return { courses, isPending, isSuccess, isError, error };
}
